import { createSlice } from '@reduxjs/toolkit';
import { ScreenState } from '@src/app/enums';
import { DocumentSummary } from 'clientportalshared';
import { getDocumentsAsync } from './thunks';

export interface DocumentsStore {
  state: ScreenState;
  error?: string;
  data: DocumentSummary[];
}

const initialState: DocumentsStore = {
  data: [],
  state: ScreenState.Loading,
  error: undefined,
} as DocumentsStore;

const documentsSlice = createSlice({
  name: 'documents',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getDocumentsAsync.fulfilled, (state, action) => {
      state.state = ScreenState.SuccessDataLoaded;
      state.data = action.payload;
    });
    builder.addCase(getDocumentsAsync.pending, (state) => {
      state.state = ScreenState.Loading;
    });
    builder.addCase(getDocumentsAsync.rejected, (state, action) => {
      state.state = ScreenState.ErrorUnableToLoadData;
      state.error = action.error.message;
    });
  },
});

export default documentsSlice.reducer;
